
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class StepsBar extends Vue {
  @Prop(String)
  labelPrefix!: string;

  @Prop(Array)
  steps!: string[];

  @Prop(Object)
  overviewLink!: Route;

  @Prop(String)
  activeStep!: string;

  firstStep(): string {
    return this.steps && this.steps.length > 0 ? this.steps[0] : '';
  }

  active(step: string): boolean {
    return this.activeStep === step;
  }
}
